function clickCrossSellCard(type, id) {
    switch (type) {
        case "coupon":
            const couponCode = document.querySelector('#coupon_code');
            const copiedTextElem = document.querySelector(`#${id} .copied-text`);
            const text = couponCode.textContent.trim();

            navigator.clipboard.writeText(text)
            .then(() => {
                console.log('Code copié dans le presse-papiers');

                copiedTextElem?.classList.add("animate");
                setTimeout(() => {
                    copiedTextElem?.classList.remove('animate');
                }, 2000);
            })
            .catch(err => {
                console.error('Erreur lors de la copie :', err);
            });

            break;
        case "product":
            const csContainer = document.getElementById(id);
            const productId = csContainer?.getAttribute("data-product-id");

            if (productId) {
                csContainer?.classList.add("loading");
                customAddToCart(productId);
            }
            break;
        default:
            console.log("default");
    }
}

function openGiftwrap() {
    const giftwrapContainer = document.querySelector(".giftwrap-drawer-container");

    giftwrapContainer?.classList.add("open");
}
function closeGiftwrap() {
    const giftwrapContainer = document.querySelector(".giftwrap-drawer-container");
    const giftWrapCheckbox = document.querySelector(".giftwrap-checkbox-container input");

    if (giftWrapCheckbox?.checked) {
        giftWrapCheckbox.checked = false;
    }
    giftwrapContainer?.classList.remove("open");
}

function addGiftwrap(productId) {
    const messageInput = document.querySelector(".giftwrap-drawer-container .message-container input[type='text']");
    var my_properties = {};

    if (messageInput) {
        my_properties.Message = messageInput.value;
    }
    customAddToCart(productId, 1, my_properties);
}

function openCartDrawer() {
    const drawer = document.querySelector("cart-drawer-component.cart-drawer button.header-actions__action");

    if (drawer)
        drawer.click();
}